import React from "react";
import "./PotLabel.scss";
import { AspectRatio } from "../api/ReplayVariables";
import sizeMe from "react-sizeme";
import NumberFormat from "react-number-format";

function PotLabel({
  size,
  zoneSize,
  realTableRatio,
  action,
  bigBlind,
  bbMode
}) {
  const cardHeight =
    AspectRatio.refBoardCardWidth *
    realTableRatio *
    AspectRatio.refBoardCardHeightRatio;
  const boardPotMargin = AspectRatio.refBoardPotMargin * realTableRatio;

  const convertToFixed = (inputnum) => {
    var mynum = inputnum.toFixed(2);
    var mynumstr = mynum.toString();
    return parseFloat(mynumstr);
  };

  const nbBB = convertToFixed(action.potSize / bigBlind, 1);

  return (
    <table
      className="pot"
      style={{
        /*
        top: top + "px",
        left: left + "px",
        width: AspectRatio.refPlayerWidth * realTableRatio + "px",
        */
        lineHeight: AspectRatio.refLineHeight * realTableRatio * 2 + "px",
        fontSize: AspectRatio.refFontSize * realTableRatio * 2 + "px",
        top:
          zoneSize.height / 2 -
          cardHeight / 2 -
          size.height -
          boardPotMargin +
          "px",
        marginLeft: "-" + size.width / 2 + "px"
      }}
    >
      <tbody>
        <tr>
          <td width="50%" align="right">
            &nbsp;POT
          </td>
          <td width="50%" align="left">
            &nbsp;
            <NumberFormat
              value={convertToFixed(bbMode ? nbBB : action.potSize)}
              displayType={"text"}
              thousandSeparator={true}
              renderText={(value) => <>{value}</>}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export default sizeMe({
  monitorHeight: true,
  monitorWidth: true
})(PotLabel);
